fx.ns("desktop.book.edition", class PhotoListWaiting extends fx.Component {
	constructor()
	{
		super();
		this.showEffect = "hslideout";
		this.hideEffect = "hslidein";
		this.destroyOnSwitch = true;
	}

	create()
	{
		super.create();

        this.backContainer = new fx.components.Box();
        this.backButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
        let text = new fx.components.Text({text : fx.text("Revenir"), className : "button-label link"});
        this.backContainer.addChild(this.backButton, {width:40, height:40, left : 0, top : 0})
        this.backContainer.addChild(text, {width: 100, height : 20, top : 10, left : 40})
        this.addChild( this.backContainer, {top : 15, left : 15, width:150, height:40});
        this.title = new fx.components.Text({text: fx.text("C'est parfait !"), className:"title center"});
        this.text = new fx.components.Text({text: fx.text("Nous attendons la réception de vos photos pour continuer.<br/> Vous serez redirigé automatiquement."), className:"text center"});

		this.addChild(this.backContainer, {top : 15, left : 15, width:150, height:40});
		this.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:200, height : 200, top : 100, left : "center"});
        this.addChild(this.title, {top: 320, width: "100%"});
        this.addChild(this.text, {top: 370, width: "100%"});
	}

	onReady()
	{
		super.onReady();
		this.listenUpdates(this.data.creation, true);
		this.on("click", this._onBack, this.backContainer);
	}

	_onBack(){
		this.data.event("step-PhotoChoicesIA");
    }

});